module.exports = __webpack_public_path__ + "static/media/img-hero-teams.aca86788.png";